import React, { useState } from 'react';
import { NodeType } from '../models';
import styles from './NodeDetails.module.scss';

interface Props {
  node: NodeType;
  onClose: () => void;
  onSave: (nodeId: string, context: string, intentCriteria: string) => void;
}

const TransferNodeDetails: React.FC<Props> = ({ node, onClose, onSave }) => {
  const data = node.context ? JSON.parse(node.context) : {};
  const [department, setDepartment] = useState(data.department || '');
  const [agent, setAgent] = useState(data.agent || '');
  const [info, setInfo] = useState(data.info || '');
  const [intentCriteria, setIntentCriteria] = useState(
    node.intentCriteria ||
      'только если пользователь просит перевести к человеку или оператору'
  );

  const handleSave = () => {
    const json = JSON.stringify({ department, agent, info });
    onSave(node.id, json, intentCriteria);
    onClose();
  };

  return (
    <div className={styles.nodeDetails}>
      <h2 className={styles.nodeDetailsTitle}>TRANSFER</h2>
      <div className={styles.nodeDetailsField}>
        <label className={styles.nodeDetailsLabel}>Intent Criteria</label>
        <textarea
          className={styles.nodeDetailsInput}
          value={intentCriteria}
          onChange={e => setIntentCriteria(e.target.value)}
          rows={3}
          placeholder="Критерии для определения intent'а"
        />
      </div>
      <div className={styles.nodeDetailsField}>
        <label className={styles.nodeDetailsLabel}>Department</label>
        <input
          className={styles.nodeDetailsInput}
          value={department}
          onChange={e => setDepartment(e.target.value)}
        />
      </div>
      <div className={styles.nodeDetailsField}>
        <label className={styles.nodeDetailsLabel}>Agent</label>
        <input
          className={styles.nodeDetailsInput}
          value={agent}
          onChange={e => setAgent(e.target.value)}
        />
      </div>
      <div className={styles.nodeDetailsField}>
        <label className={styles.nodeDetailsLabel}>Info</label>
        <textarea
          className={styles.nodeDetailsInput}
          value={info}
          onChange={e => setInfo(e.target.value)}
          rows={3}
        />
      </div>
      <div className={styles.nodeDetailsButtons}>
        <button className={styles.cancelButton} onClick={onClose}>
          Cancel
        </button>
        <button className={styles.saveButton} onClick={handleSave}>
          Save
        </button>
      </div>
    </div>
  );
};

export default TransferNodeDetails;
